import * as React from 'react'
import { ErrorPage } from '@components/error-page'

export const Error500 = (): JSX.Element => <ErrorPage code={500} text={<span>Błąd wewnętrzny serwera</span>} />
